import { FC } from 'react'

import styled from 'styled-components'

import { useFirstChosenTrack } from 'src/Hooks/useFirstChosenTrack'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'

import { NoAuthPageLayout } from '../../Components/NoAuthPageLayout'
import { CreateCampaignBreadcrumbsNoAuth } from '../../Components/CreateCampaignBreadcrumbsNoAuth'
import { HelmetTitle } from '../../Components/HelmetTitle'

import { useArtistRegisterPage } from './useArtistRegisterPage'
import { ArtistRegisterContent } from './Components/ArtistRegisterContent'

const Container = styled.div`
  display: flex;
  max-width: 960px;
  margin: 0 auto;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    gap: 40px;
  }
`

export const ArtistRegisterPage: FC = () => {
  const {
    handleSubmit,
    onGoogleClick,
    isEmailExist,
    clearEmailExist,
    loading: isRegisterLoading,
    onStartFillingForm,
  } = useArtistRegisterPage()

  const { unifyTrack, platform, loading } = useFirstChosenTrack()

  return (
    <NoAuthPageLayout>
      <HelmetTitle />

      <Container>
        <CreateCampaignBreadcrumbsNoAuth platform={platform} />
        <ArtistRegisterContent
          isEmailExist={isEmailExist}
          clearEmailExist={clearEmailExist}
          isRegisterLoading={isRegisterLoading}
          onSubmitRegisterForm={handleSubmit}
          onGoogleClick={onGoogleClick}
          onStartFillingForm={onStartFillingForm}
          isTrackDataLoading={loading}
          trackCoverUrl={unifyTrack?.trackCoverUrl}
          trackName={unifyTrack?.trackName}
          artistName={unifyTrack?.artistName}
          trackDuration={unifyTrack?.trackDuration}
          trackPreviewUrl={unifyTrack?.trackPreviewUrl}
          platform={platform}
        />
      </Container>
    </NoAuthPageLayout>
  )
}
